import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { ChatProvider } from "@/lib/chat";
import { FavouritesProvider } from "@/lib/favourites";
import Landing from "@/pages/Landing";
import SellMyBike from "@/pages/SellMyBike";
import ListMyBike from "@/pages/ListMyBike";
import Marketplace from "@/pages/Marketplace";
import ListingDetail from "@/pages/ListingDetail";
import GoogleCallback from "@/pages/GoogleCallback";
import Dashboard from "@/pages/Dashboard";
import Messages from "@/pages/Messages";
import AdminDashboard from "@/pages/AdminDashboard";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsConditions from "@/pages/TermsConditions";
import ContactUs from "@/pages/ContactUs";
import Favourites from "@/pages/Favourites";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/sell-my-bike" element={<SellMyBike />} />
      <Route path="/list-my-bike" element={<ListMyBike />} />
      <Route path="/marketplace" element={<Marketplace />} />
      <Route path="/marketplace/:id" element={<ListingDetail />} />
      <Route path="/auth/google" element={<GoogleCallback />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/messages" element={<Messages />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsConditions />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/favourites" element={<Favourites />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <FavouritesProvider>
            <ChatProvider>
              <AppRouter />
            </ChatProvider>
          </FavouritesProvider>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
